/* src/app/components/card-preview/card-preview.component.scss */
.card-scene {
  perspective: 1200px;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}
.card-3d {
  position: relative;
  width: 100%;
  aspect-ratio: 1.586;
  transform-style: preserve-3d;
  transition: transform 0.5s cubic-bezier(0.4, 0.2, 0.2, 1);
}
.card-3d.is-flipped {
  transform: rotateY(180deg);
}
.card-face {
  position: absolute;
  inset: 0;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  border-radius: var(--yf-border-radius, 12px);
  box-shadow: var(--yf-shadow, 5px 5px 10px rgba(0, 0, 0, 0.1215686275));
  color: #fff;
  overflow: hidden;
  background:
    linear-gradient(
      135deg,
      var(--yf-secondary, #002945) 0%,
      var(--yf-primary, #297eb2) 100%);
}
.card-face::after {
  content: "";
  position: absolute;
  inset: 0;
  background:
    radial-gradient(
      circle at 85% -20%,
      rgba(255, 255, 255, 0.18) 0%,
      transparent 55%);
  pointer-events: none;
}
.card-front {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 8% 7%;
}
.card-top {
  display: flex;
  align-items: center;
  gap: 12px;
}
.card-top .chip {
  width: 44px;
  height: 32px;
  border-radius: 6px;
  background:
    linear-gradient(
      90deg,
      transparent 47%,
      rgba(0, 0, 0, 0.25) 47%,
      rgba(0, 0, 0, 0.25) 53%,
      transparent 53%),
    linear-gradient(
      0deg,
      transparent 40%,
      rgba(0, 0, 0, 0.25) 40%,
      rgba(0, 0, 0, 0.25) 46%,
      transparent 46%),
    linear-gradient(
      135deg,
      #e8d48b 0%,
      #c8a951 50%,
      #e8d48b 100%);
}
.card-top .contactless {
  transform: rotate(90deg);
  font-size: 22px;
  opacity: 0.85;
}
.card-top .brand {
  margin-left: auto;
  height: 34px;
  max-width: 64px;
  object-fit: contain;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3));
}
.card-number {
  display: flex;
  justify-content: space-between;
  font-size: clamp(17px, 5.2vw, 23px);
  letter-spacing: 0.08em;
  font-variant-numeric: tabular-nums;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
}
.card-number .group {
  min-width: 4ch;
  text-align: center;
}
.card-bottom {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 12px;
}
.card-bottom .field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.card-bottom .label {
  font-size: 9px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  opacity: 0.7;
  margin-bottom: 2px;
  white-space: nowrap;
}
.card-bottom .value {
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-bottom .owner {
  flex: 1;
}
.card-back {
  transform: rotateY(180deg);
  display: flex;
  flex-direction: column;
}
.card-back .magstripe {
  height: 20%;
  background: #14141a;
  margin-top: 10%;
}
.card-back .signature-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 8% 7% 0;
}
.card-back .signature-row .signature {
  flex: 1;
  height: 34px;
  border-radius: 4px;
  background:
    repeating-linear-gradient(
      0deg,
      #f4f4f4,
      #f4f4f4 6px,
      #e3e3e3 6px,
      #e3e3e3 8px);
}
.card-back .signature-row .cvv-box {
  min-width: 56px;
  padding: 6px 10px;
  border-radius: 4px;
  background: #fff;
  color: #14141a;
  font-weight: 700;
  letter-spacing: 0.2em;
  text-align: center;
  font-variant-numeric: tabular-nums;
}
.card-back .brand-back {
  margin: auto 7% 8% auto;
  height: 28px;
  max-width: 56px;
  object-fit: contain;
  opacity: 0.85;
}
/*# sourceMappingURL=card-preview.component.css.map */
